export const ResizeIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.5 6V2H6.5L8.145 3.645L3.145 8.645L1.5 7V11H5.5L3.855 9.355L8.855 4.355L10.5 6Z"
      fill="#308CBF"
    />
  </svg>
);
